import { SUPABASE_URL, getDbHeaders } from "./client";

export async function dbLoadEntriesRange(startDate, endDate) {
  const res = await fetch(
    `${SUPABASE_URL}/rest/v1/connection_analytics?date=gte.${startDate}&date=lte.${endDate}&order=date.asc`,
    { headers: await getDbHeaders() }
  );
  if (!res.ok) return [];
  return res.json();
}
